﻿<template>
    <!-- passengers already on the booking: tick to add them to this trip -->
    <div v-if="passengers?.length > 0" class="pp-existing">
        <p class="pp-seats">Passengers on this booking</p>
        <ul class="pp-list">
            <li v-for="passenger in passengers" :key="passenger.passenger_identifier">
                <label class="pp-check">
                    <input type="checkbox" :checked="Passenger_Selected(passenger)" class="focus:ring-action h-4 w-4 text-action border-grey-light rounded" @change="Toggle_Passenger(passenger)">
                    {{passenger.first_name}} {{passenger.family_name}}
                </label>
            </li>
        </ul>
    </div>
</template>

<script lang="ts" src="./existing_passengers.ts"></script>
